/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Goal Tracking — goal list, rule builder, conversion viewer (timeline + funnel). */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["goal-tracking"] = "1.0.3"; } catch (e) {}
  function ic(n){ return (window.GSIcons&&GSIcons.svg)?(GSIcons.svg(n,16)+" "):""; }
  var root;
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function on(n,ev,fn){ var el=q(n); if(el) el.addEventListener(ev,fn); return el; }
  function qa(s){ return root?Array.prototype.slice.call(root.querySelectorAll(s)):[]; }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function val(el){ return el?el.value.trim():""; }
  function ready(fn){ var d=false; function go(){ if(d)return; d=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }

  var LIST=[];
  function statusBadge(s){ return '<span class="g-status '+(s==="active"?"on":"off")+'">'+esc(s)+'</span>'; }

  function loadList(){ GS.api("/plugin/goal-tracking/list?site="+encodeURIComponent(GS.site)).then(function(r){ LIST=(r.ok&&r.data&&r.data.goals)||[]; renderList(); }); }
  function renderList(){
    var tb=q("tbody");
    function goalRow(g){
      return '<tr data-row="'+g.id+'"><td class="gn">'+ic("goal-tracking")+esc(g.name)+"</td>"+
        '<td class="cap">'+esc(g.kind)+"</td><td class=\"cap\">"+(g.match_type==="all"?"All":"Any")+"</td>"+
        '<td class="r">'+(g.rule_count||0)+"</td><td>"+statusBadge(g.status)+"</td>"+
        '<td class="r nowrap"><button class="g-mini" data-edit="'+g.id+'"><i class="bi bi-pencil"></i></button> <button class="g-mini danger" data-del="'+g.id+'"><i class="bi bi-trash"></i></button></td></tr>';
    }
    if (window.GSMore) GSMore.mount({ container:tb, table:true, colspan:6, items:LIST, pageSize:20, emptyText:TR('goaltr.f3.no_goals_yet_click_u201cnew_goal_u'), render:goalRow });
    else tb.innerHTML = LIST.length ? LIST.map(goalRow).join("") : '<tr><td colspan="6" class="empty">'+TR('goaltr.f2.no_goals_yet')+'</td></tr>';
    // One delegated listener on the tbody covers rows AND their edit/delete buttons, including
    // rows revealed later by "Load more" (per-element binding only reached the first page).
    if(!tb._goalDelegated){ tb._goalDelegated=1;
      tb.addEventListener("click",function(e){
        var ed=e.target.closest&&e.target.closest("[data-edit]"); if(ed){ editGoal(+ed.getAttribute("data-edit")); return; }
        var dl=e.target.closest&&e.target.closest("[data-del]");  if(dl){ delGoal(+dl.getAttribute("data-del")); return; }
        var tr=e.target.closest&&e.target.closest("tr[data-row]"); if(tr) openViewer(+tr.getAttribute("data-row"));
      });
    }
  }

  function openViewer(id){
    if (window.GSLink) window.GSLink.write({ id: id });   // the open view becomes linkable
    GS.api("/plugin/goal-tracking/stats?site="+encodeURIComponent(GS.site)+"&goal="+id+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data||!r.data.available)return; renderViewer(r.data);
    });
  }
  function renderViewer(d){
    var v=q("viewer"); v.hidden=false;
    q("viewer-title").textContent=(d.goal&&d.goal.name)||"Goal";
    q("k-conv").textContent=(d.conversions||0).toLocaleString();
    q("k-rate").textContent=(d.conv_rate||0)+"%";
    q("k-vis").textContent=(d.visitors||0).toLocaleString();
    q("k-total").textContent=(d.total_sessions||0).toLocaleString();
    // timeline
    var tl=d.timeline||[], max=1; tl.forEach(function(x){ if(x.conversions>max)max=x.conversions; });
    q("timeline").innerHTML= tl.length ? tl.map(function(x){
      return '<div class="g-tlcol" title="'+esc(x.date)+": "+x.conversions+'"><i style="height:'+Math.max(3,(x.conversions/max*100))+'%"></i></div>';
    }).join("") : '<div class="empty">'+TR('goaltr.f2.no_conversions_in_this_range')+'</div>';
    // funnel
    var fp=q("funnel-panel"), fn=d.funnel||[];
    if(fn.length){ fp.hidden=false; var top=fn[0].sessions||1;
      q("funnel").innerHTML=fn.map(function(s,i){ var pct=top?Math.round(s.sessions/top*100):0;
        var drop=(i>0&&fn[i-1].sessions)?Math.round((fn[i-1].sessions-s.sessions)/fn[i-1].sessions*100):0;
        return '<div class="g-fstep"><div class="g-fhead"><span>'+esc(s.step)+'</span><span>'+s.sessions.toLocaleString()+(i>0?' <em>-'+drop+'%</em>':'')+'</span></div><div class="g-fbar"><i style="width:'+Math.max(2,pct)+'%"></i></div></div>';
      }).join(""); } else fp.hidden=true;
    v.scrollIntoView({behavior:"smooth",block:"nearest"});
  }

  /* builder */
  function bf(k){ return root.querySelector('[data-bf="'+k+'"]'); }
  function openBuilder(g){
    q("builder").hidden=false; q("viewer").hidden=true;
    q("builder-title").textContent=g?("Edit \u2014 "+g.name):TR('goaltr.g.new_goal');
    bf("id").value=g?g.id:"";
    ["name","description","kind","match_type","status"].forEach(function(k){ bf(k).value=g?(g[k]||""):(k==="kind"?"macro":(k==="match_type"?"all":(k==="status"?"active":""))); });
    var host=q("rules"); host.innerHTML="";
    var rs=(g&&g.rules&&g.rules.length)?g.rules:[{rule_type:"url",value:""}];
    rs.forEach(addRule);
    q("builder").scrollIntoView({behavior:"smooth",block:"start"});
  }
  function addRule(data){
    data=data||{rule_type:"url",value:""};
    var tpl=document.getElementById("goal-rule-tpl"); if(!tpl)return;
    var node=tpl.content.firstElementChild.cloneNode(true);
    node.querySelector('[data-rf="rule_type"]').value=data.rule_type||"url";
    node.querySelector('[data-rf="value"]').value=data.value||"";
    node.querySelector("[data-rdel]").addEventListener("click",function(){ node.remove(); });
    q("rules").appendChild(node);
  }
  function collect(){
    var rules=qa("[data-grow]").map(function(r){ return { rule_type:r.querySelector('[data-rf="rule_type"]').value, value:val(r.querySelector('[data-rf="value"]')) }; })
      .filter(function(r){ return r.value!==""||r.rule_type==="url"; });
    return { id:bf("id").value?+bf("id").value:0, name:val(bf("name")), description:val(bf("description")),
      kind:bf("kind").value, match_type:bf("match_type").value, status:bf("status").value, rules:rules };
  }
  function saveBuilder(){
    var p=collect(); if(!p.name){ q("builder-status").textContent=TT('gt.a.name_required'); return; }
    var st=q("builder-status"); st.textContent=TT('gt.a.saving_u2026');
    GS.api("/plugin/goal-tracking/"+(p.id?"update":"create")+"?site="+encodeURIComponent(GS.site),{method:"POST",body:JSON.stringify(p)}).then(function(r){
      if(r.ok&&r.data&&(r.data.ok||r.data.id)){ st.textContent=TT('gt.a.saved_u2713'); q("builder").hidden=true; loadList(); } else st.textContent=TT('gt.a.error');
    });
  }
  function editGoal(id){ GS.api("/plugin/goal-tracking/get?site="+encodeURIComponent(GS.site)+"&id="+id).then(function(r){ if(r.ok&&r.data&&r.data.id)openBuilder(r.data); }); }
  function delGoal(id){ var g=LIST.filter(function(e){return e.id===id;})[0]; if(!confirm(TT('gt.x.delete_goal')+' '+(g?('"'+g.name+'"'):"#"+id)+"?"))return;
    GS.api("/plugin/goal-tracking/delete?site="+encodeURIComponent(GS.site),{method:"POST",body:JSON.stringify({id:id})}).then(function(){ q("viewer").hidden=true; loadList(); }); }

  /* range */
  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={7:T("an.last7"),30:T("an.last30"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_goal_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(30); })();
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_goal_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; loadList(); }); });
    var _ap=menu.querySelector('[data-rp="apply"]');if(_ap)_ap.addEventListener("click",function(){var ff=(menu.querySelector('[data-rp="from"]')||{}).value,tt=(menu.querySelector('[data-rp="to"]')||{}).value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}RANGE={from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null};if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_goal-tracking_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";loadList();});
    btn.addEventListener("click",function(){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf&&RANGE.from)cf.value=RANGE.from;if(ct&&RANGE.to)ct.value=RANGE.to;});
  }
  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    on("new-goal","click",function(){ openBuilder(null); });
    on("add-rule","click",function(){ addRule(null); });
    on("builder-save","click",saveBuilder);
    on("builder-cancel","click",function(){ q("builder").hidden=true; });
    on("builder-close","click",function(){ q("builder").hidden=true; });
    initRange(); loadList();
  }
  /* Deep link: /goal-tracking?id=<v> opens that view directly, so it can be linked from an email,
     a dashboard widget or another report. The spelling lives in GSLink so no two pages can
     disagree about it. The inline fallback covers the window before gs-deeplink.js is deployed —
     it must ASSIGN, not return: an early return exits gsDeep() and the opener never fires.
     Anything malformed is ignored and the normal list loads. */
  function gsDeep() {
    var v = null;
    if (window.GSLink) {
      v = window.GSLink.read({ id: "int" }).id;
    } else {
      try {
        var p = new URLSearchParams(location.search);
        var _n = parseInt(String(p.get("id") || "").replace(/[^0-9-]/g, ""), 10);
        v = isNaN(_n) ? null : _n;
      } catch (e) { v = null; }
    }
    if (v !== null && v !== "") openViewer(v);
  }
  ready(function () { init(); gsDeep(); });
})();
